import { makeRequest } from 'utils/requestLogger';

export default (participationID, pointTag) =>
  makeRequest(
    'post',
    `/api/participations/${participationID}/give_impression`,
    { tag: pointTag }
  );
// joao has to handle when i toggle, give/take back



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/togglePoints.js